export default __webpack_public_path__ + "static/media/kiama2.983f337c.jpg";